import { useFormContext } from 'react-hook-form';
import { debounce } from 'lodash';
import { useFormWithStateContext } from 'contexts/FormWithStateContext';
import { realisation as rules } from 'further-ui/validations';
import { RealisationFormState } from '../types';
import { CurrencyCode } from 'further-types/lp/vehicle';

const useClearConsiderationForm = ({
  vehicleCurrencyCode,
}: {
  vehicleCurrencyCode: CurrencyCode;
}) => {
  const { reset, getValues } = useFormContext();
  const { setState, state } = useFormWithStateContext<
    rules.CreateRealisationFormValues,
    RealisationFormState
  >();

  const clearConsiderationForm = () => {
    const currentValues = getValues();

    // Reset the form with current values but cleared consideration fields
    reset({
      ...currentValues,

      consideration: currentValues.consideration.map((consideration) => ({
        ...consideration,
        currency: vehicleCurrencyCode,
        proRataConsideration: {
          receivedConsiderationPerUnit: undefined,
          receivedConsiderationTotal: undefined,
          escrowConsiderationPerUnit: undefined,
          escrowConsiderationTotal: undefined,
          earnoutConsiderationPerUnit: undefined,
          earnoutConsiderationTotal: undefined,
          withholdingTaxPayable: undefined,
        },
      })),
      holdingClassRealisation: currentValues.holdingClassRealisation.map(
        (holdingClass) => ({
          ...holdingClass,
          cashConsiderationAmounts: {
            receivedConsiderationPerUnit: undefined,
            receivedConsiderationTotal: undefined,
            escrowConsiderationPerUnit: undefined,
            escrowConsiderationTotal: undefined,
            earnoutConsiderationPerUnit: undefined,
            earnoutConsiderationTotal: undefined,
            withholdingTaxPayable: undefined,
          },
        }),
      ),
    });

    setState({
      consideration: state.consideration.map(({ index, ...rest }) => ({
        ...rest,
        index,
        showAllocationsTable: false,
        disableAllocationsInputs: false,
      })),
    });
  };

  // Create the debounced function properly
  const debouncedClearConsiderationForm = debounce(clearConsiderationForm, 300);

  return { clearConsiderationForm, debouncedClearConsiderationForm };
};

export default useClearConsiderationForm;
